import { Button, Form, Modal, message } from "antd";
import { useForm } from "antd/lib/form/Form";
import { useState } from "react";
import { useUpdateMP3 } from "../../apiConnection/MP3Connection";
import { UpdateMp3Dto } from "../../types/entities/dto/update.mp3.dto";
import { MP3 } from "../../types/entities/mp3.entity";
import { parseApiError } from "../../utils/helperFuncs";
import { BasicButton } from "../inputs/BasicButton";
import { BasicInput } from "../inputs/BasicInput";

interface MP3EditModalProps {
  mp3: MP3;
}
interface ModalState {
  visible: boolean;
  modalLoading: boolean;
}

export const MP3EditModal: React.FC<MP3EditModalProps> = ({ mp3 }) => {
  const [modalState, setModalState] = useState<ModalState>({
    visible: false,
    modalLoading: false,
  });

  const [form] = useForm();

  const { mutate: updateMp3 } = useUpdateMP3();

  const resetModalState = () => {
    form.resetFields();
    closeModal();
  };

  const saveUpdateMp3 = (mp3Update: UpdateMp3Dto) => {
    setModalState((state) => ({
      ...state,
      modalLoading: true,
    }));

    updateMp3(
      { id: mp3.id, mp3Update },
      {
        onSuccess: () => {
          message.success("Update erfolgreich.");
          closeModal();
        },
        onError: (error) => {
          message.error(parseApiError(error).statusText);
          resetModalState();
        },
      }
    );
  };

  const showModal = () => {
    setModalState({
      modalLoading: false,
      visible: true,
    });
  };

  const closeModal = () => {
    setModalState({
      modalLoading: false,
      visible: false,
    });
  };

  return (
    <>
      <BasicButton type="primary" onClick={showModal}>
        Edit
      </BasicButton>
      <Modal
        title={"Edit ID3 Tags"}
        open={modalState.visible}
        confirmLoading={modalState.modalLoading}
        footer={[
          <Button
            key="cancel"
            onClick={resetModalState}
            disabled={modalState.modalLoading}
          >
            Cancel
          </Button>,
        ]}
        onCancel={resetModalState}
      >
        <>
          <Form
            form={form}
            onFinish={saveUpdateMp3}
            initialValues={mp3}
            layout="vertical"
          >
            <Form.Item
              label="Title"
              name="title"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <BasicInput />
            </Form.Item>
            <Form.Item
              label="Von"
              name="artist"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <BasicInput />
            </Form.Item>
            <Form.Item
              label="Album"
              name="album"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <BasicInput />
            </Form.Item>
            <Form.Item
              label="Art"
              name="genre"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <BasicInput />
            </Form.Item>
            <Form.Item
              label="Track Nr"
              name="trackNr"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <BasicInput />
            </Form.Item>
            <Form.Item
              label="Jahr"
              name="year"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <BasicInput />
            </Form.Item>
            <Button
              type="primary"
              shape="round"
              htmlType="submit"
              disabled={modalState.modalLoading}
            >
              Speichern
            </Button>
          </Form>
        </>
      </Modal>
    </>
  );
};
